import axiosInstance from 'services/axiosMiddleware';

export async function sendInvite(coachData) {
  try {
    const response = await axiosInstance.post('/invite/send-invite', coachData);

    if (response.data.status) {
      return {
        message: response.data.message,
        token: response.data.token,
        inviteLink: response.data.inviteLink
      };
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error sending invite:', error);
    throw error;
  }
}
